module.exports = __webpack_public_path__ + "static/PetronelaBodnárová-5f87328fc066edc8dff5994f348421db.jpg";